import { Link } from 'react-router-dom';
import { categories } from '@/mocks/anime';

const categoryImages = [
  'https://readdy.ai/api/search-image?query=Japanese%20anime%20art%20style%20illustration%20with%20warm%20orange%20and%20coral%20tones%2C%20traditional%20Japanese%20temple%20and%20cherry%20blossoms%2C%20soft%20dreamy%20atmosphere%2C%20clean%20flat%20illustration%20style%2C%20simple%20elegant%20composition&width=600&height=400&seq=cat-japanese&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Chinese%20donghua%20animation%20style%20illustration%20with%20warm%20golden%20and%20coral%20tones%2C%20ancient%20Chinese%20architecture%20and%20mountains%2C%20misty%20atmosphere%2C%20clean%20flat%20illustration%20style%2C%20simple%20elegant%20composition&width=600&height=400&seq=cat-chinese&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Anime%20art%20style%20illustration%20with%20vibrant%20warm%20fire%20and%20energy%20effects%2C%20dynamic%20composition%2C%20orange%20and%20amber%20color%20palette%2C%20clean%20flat%20illustration%20style%2C%20simple%20dramatic%20background&width=600&height=400&seq=cat-hot&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Anime%20art%20style%20illustration%20with%20vintage%20warm%20nostalgic%20tones%2C%20retro%20Japanese%20anime%20aesthetic%2C%20film%20grain%20texture%2C%20clean%20flat%20illustration%20style%2C%20simple%20warm%20composition&width=600&height=400&seq=cat-classic&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cinematic%20anime%20style%20illustration%20with%20warm%20theater%20lighting%20and%20film%20reel%20elements%2C%20dramatic%20orange%20and%20coral%20color%20palette%2C%20clean%20flat%20illustration%20style%2C%20simple%20elegant%20composition&width=600&height=400&seq=cat-movie&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Anime%20art%20style%20illustration%20with%20warm%20cozy%20home%20entertainment%20vibe%2C%20DVD%20collection%20aesthetic%2C%20soft%20amber%20lighting%2C%20clean%20flat%20illustration%20style%2C%20simple%20comfortable%20composition&width=600&height=400&seq=cat-ova&orientation=landscape',
];

export default function CategorySection() {
  return (
    <section className="bg-background-100/70 py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型找到你喜欢的动漫</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat, index) => (
            <Link
              key={cat.id}
              to={`/category?tab=${cat.slug}`}
              className="group relative rounded-lg overflow-hidden aspect-[3/2] bg-background-200 cursor-pointer"
            >
              <img
                src={categoryImages[index]}
                alt={cat.name}
                title={cat.name + ' - 奶片动漫' + cat.description}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <div className="flex items-center gap-1.5">
                  <span className="w-5 h-5 flex items-center justify-center text-white/90">
                    <i className={`${cat.icon} text-sm`}></i>
                  </span>
                  <span className="text-white font-semibold text-sm">{cat.name}</span>
                </div>
                <p className="text-white/60 text-xs mt-0.5">{cat.count}部作品</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}